import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var TaxSVG = function TaxSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26,2H6C3.5,2,2,3.87,2,7V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V7c0-2.8,1.68-3,2-3,.08,0,2,0,2,3a3.44,3.44,0,0,1-2.32,3.05,1,1,0,1,0,.64,1.9C26.47,11.9,30,10.68,30,7,30,3,27.38,2,26,2ZM7,6h6a1,1,0,0,1,0,2H7A1,1,0,0,1,7,6Zm8,14a1,1,0,1,1-1-1A1,1,0,0,1,15,20ZM9,12H7a1,1,0,0,1,0-2H9a1,1,0,0,1,0,2ZM20,27a1,1,0,1,1,1-1A1,1,0,0,1,20,27Zm.71-6.29-6,6a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42l6-6a1,1,0,0,1,1.42,1.42Z"
  }));
};
TaxSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TaxSVG);